import { Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import LoadingPage from 'src/components/loading-page/loading-page';
import { usePromoterTerms } from './promoter-terms.hook';
import PromoterTermsForm from './components/promoter-terms-form';

export default function PromoterTerms() {
  const hook = usePromoterTerms();

  return (
    <Page title="Termos do Promotor">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs links={[]} heading="Termos do Promotor" />
        {hook.loading ? <LoadingPage /> : <PromoterTermsForm hook={hook} />}
      </Container>
    </Page>
  );
}
